import { Routes, RouterModule } from "@angular/router";
import { VppOperatorLookupComponent } from "./vpp-operator-lookup/vpp-operator-lookup.component";
import { VppOperatorComponent } from "./vpp-operator/vpp-operator.component";
import { VppPreRegisterComponent } from "./vpp-pre-register/vpp-pre-register.component";
import { AuthguardService } from "../master/services";

export const Vpp3Routes: Routes = [
	// { path: "", redirectTo: "/visitor/passdesign", pathMatch: "full" },
	{
		path: "preregistration",
		data: { title: "Pre-Registration" },
		component: VppPreRegisterComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "operator",
		data: { title: "VPP Operator" },
		component: VppOperatorComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "operator/:VisitorID",
		data: { title: "VPP Offender Lookup" },
		component: VppOperatorLookupComponent,
		canActivate: [AuthguardService],
	},
];
